import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import * as Icon from "react-feather";
import {checkRoutePermission} from "../auth/AuthUtils";
import {sessionUser} from "../config";

class SideBar extends Component {

  render() {
    let {navPx} = this.props;

    return (
      <div id="layoutSidenav_nav">
        <nav style={{paddingTop: `${64 + navPx}px`}} className="sidenav shadow-right sidenav-light">
          <div className="sidenav-menu">
            <div className="nav accordion" id="accordionSidenav">
              <div className="sidenav-menu-heading">Home</div>
              <NavLink className="nav-link" to={"/projectViewer?project_id="+document.getElementById('projectSelected').getAttribute('name')}>
                <div className="nav-link-icon">
                  <Icon.Activity size={18} />
                </div>
                Dashboard
              </NavLink>

              {(checkRoutePermission("/projects") || checkRoutePermission("/dataSource") || checkRoutePermission("/users")) &&
                <div className="sidenav-menu-heading">Admin</div>
              }
              {checkRoutePermission("/projects") &&
                <NavLink className="nav-link" to="/projects">
                  <div className="nav-link-icon">
                    <Icon.Layers size={18}/>
                  </div>
                  Projects
                </NavLink>
              }

              {checkRoutePermission("/dataSource") &&
                <NavLink className="nav-link" to="/dataSource">
                  <div className="nav-link-icon">
                    <Icon.Database size={18}/>
                  </div>
                  Data Source
                </NavLink>
              }

              {/* <NavLink className="nav-link" to="/forms">
                <div className="nav-link-icon">
                  <Icon.FileText size={18} />
                </div>
                Forms
              </NavLink> */}

              {/* <NavLink className="nav-link" to="/lists">
                <div className="nav-link-icon">
                  <Icon.List size={18} />
                </div>
                Lists
              </NavLink> */}

              {checkRoutePermission("/users") &&
                <NavLink className="nav-link" to="/users">
                  <div className="nav-link-icon">
                    <Icon.Users size={18} />
                  </div>
                  Users
                </NavLink>
              }
              {checkRoutePermission("/institutions") &&
                  <NavLink className="nav-link" to="/institutions">
                    <div className="nav-link-icon">
                      <Icon.Globe size={18} />
                    </div>
                    Institutions
                  </NavLink>
              }
                {
                 checkRoutePermission("/appConfigurations") &&
                  <NavLink className="nav-link" to="/appConfigurations">
                    <div className="nav-link-icon">
                      <Icon.Settings size={18} />
                    </div>
                    App Settings
                  </NavLink>
              }
              {(checkRoutePermission("/reportBuilder") || checkRoutePermission("/reportViewer")) &&
                <div className="sidenav-menu-heading">Analytics</div>
              }
              {checkRoutePermission("/reportBuilder") &&
                <NavLink className="nav-link" to="/reportBuilder">
                  <div className="nav-link-icon">
                    <Icon.Scissors size={18}/>
                    </div>
                  Reports
                </NavLink>
              }
              {/* {checkRoutePermission("/reportViewer") &&
                <NavLink className="nav-link" to="/reportViewer">
                  <div className="nav-link-icon">
                    <Icon.TrendingUp size={18} />
                  </div>
                  Report Viewer
                </NavLink>
              } */}
            </div>
          </div>
          <div className="sidenav-footer">
            <div className="sidenav-footer-content">
              <div className="sidenav-footer-subtitle">
                Logged in as:
              </div>
              <div className="sidenav-footer-title">
                {sessionStorage.getItem(sessionUser) != null && JSON.parse(sessionStorage.getItem(sessionUser))['Username']}
              </div>
            </div>
            <button
                style={{marginLeft: "auto"}}
                className="btn btn-transparent-dark order-2 order-lg-0 mr-lg-2"
                id="sidebarToggle"
                onClick={() => this.props.handleToggle()}
            >
              <Icon.Menu />
            </button>
          </div>
        </nav>
      </div>
    );
  }
}

export default withRouter(SideBar);
